module.exports = __webpack_public_path__ + "assets/img/create_child_item.e9a9f1b4.png";